module.exports = __webpack_public_path__ + "static/media/Cowboy619_3c.15f38f81.svg";